module.exports = __webpack_public_path__ + "img/41ne.e1b8f489.svg";